<template>
  <div class="measures">
    <div class="switcher-block">
      <switcher :isActive="Boolean(increaseRisk)" @onClick="increaseRisk = !increaseRisk" />
      <main-text>
        Увеличить нормативные значения индивиндуального пожарного риска до 10<sup>-4</sup> в зданиях, сооружениях и на
        территориях производственных объектов
      </main-text>
    </div>
    <div class="info-block">
      <main-text> Ст.93 п.3 ФЗ-123 </main-text>
      <div class="info-text">
        <main-text>3. </main-text>
        <main-text>
          Для производственных объектов, на которых обеспечение величины индивидуального пожарного риска одной
          миллионной в год невозможно в связи со спецификой функционирования технологических процессов, допускается
          увеличение индивидуального пожарного риска до одной десятитысячной в год. При этом должны быть предусмотрены
          меры по обучению персонала действиям при пожаре и по социальной защите работников, компенсирующие их работу в
          условиях повышенного риска.
        </main-text>
      </div>
    </div>

    <div class="switcher-block">
      <switcher :isActive="Boolean(increaseSRisk)" @onClick="increaseSRisk = !increaseSRisk" />
      <main-text>
        Увеличить нормативные значения индивидуального пожарного риска до 10<sup>-6</sup> и (или) величины социального
        пожарного риска до 10<sup>-5</sup> для людей, находящихся в жилой зоне, общественно-деловой зоне или зоне
        рекреационного назначения вблизи объекта
      </main-text>
    </div>
    <div class="info-block">
      <main-text> Ст.93 п.4.1 ФЗ-123 </main-text>
      <div class="info-text">
        <main-text>4.1. </main-text>
        <main-text>
          Для производственных объектов, на которых для людей, находящихся в жилой зоне, общественно-деловой зоне или
          зоне рекреационного назначения вблизи объекта, обеспечение величины индивидуального пожарного риска одной
          стомиллионной в год и (или) величины социального пожарного риска одной десятимиллионной в год невозможно в
          связи со спецификой функционирования технологических процессов, допускается увеличение индивидуального
          пожарного риска до одной миллионной в год и (или) социального пожарного риска до одной стотысячной в год
          соответственно. При этом должны быть предусмотрены средства оповещения людей, находящихся в жилой зоне,
          общественно-деловой зоне или зоне рекреационного назначения, о пожаре на производственном объекте, а также
          дополнительные инженерно-технические и организационные мероприятия по обеспечению их пожарной безопасности и
          социальной защите.
        </main-text>
      </div>
    </div>

    <div class="form-button-block">
      <main-button :loading="loading" class="form-button" @click="save()">Сохранить</main-button>

      <main-button @click="$emit('onCancelClick')" color="link">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import MainButton from "../../../components/ui/MainButton.vue";
import Switcher from "../../../components/ui/Switcher.vue";
import MainText from "../../../components/ui/Text.vue";
export default {
  name: "measures",
  props: {
    project: Object,
  },
  data() {
    return {
      increaseRisk: false,
      increaseSRisk: false,
      loading: false,
    };
  },
  components: { Switcher, MainText, MainButton },
  created() {
    this.increaseRisk = this.project.increaseRisk;
    this.increaseSRisk = this.project.increaseSRisk;
  },
  methods: {
    save() {
      this.loading = true;

      this.$http
        .post("projects/measures-update?id=" + this.project.id, {
          increaseRisk: Number(this.increaseRisk),
          increaseSRisk: Number(this.increaseSRisk),
        })
        .then(() => {
          const isIncreaseRiskChanged = !(Boolean(this.project.increaseRisk) === this.increaseRisk);
          const isIncreaseSRiskChanged = !(Boolean(this.project.increaseSRisk) === this.increaseSRisk);
          if (isIncreaseRiskChanged || isIncreaseSRiskChanged) {
            this.$emit("clearCalculations");
          }
          this.project.increaseRisk = this.increaseRisk;
          this.project.increaseSRisk = this.increaseSRisk;
          this.$emit("measuresHide");
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.measures {
  padding: 0;
}
.switcher-block {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 24px;
}
.info-block {
  padding: 12px;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  background: var(--white-color);
  margin: 0 24px 32px;
}
.info-text {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
</style>
